import { Format } from 'ajv';
import { FormatType } from '../../types';

export const validateJson = (value?: string | undefined | null) => {
  if (typeof value !== 'string') return false;

  try {
    JSON.parse(value);
  } catch {
    return false;
  }

  return true;
};

const jsonFormat: Format = {
  type: 'string',
  validate: validateJson,
};

export const jsonFormatEntry = {
  name: FormatType.JsonLogic,
  format: jsonFormat,
};
